import { Action } from '../../../redux/redux.types';
import { ReplicationsListFilter } from '../replications.types';

import { REPLICATIONS_LIST_ACTION_NAMES } from './replications-list.actions';
import { REPLICATIONS_UI_ACTION_NAMES } from './replications-ui.actions';

export interface ReplicationsUiState {
  replicationsListFilter: ReplicationsListFilter;
  selectedReplicationId: string | undefined;
  selectedReplicationVersionId: number | undefined;
  isVersionDetailsOpened: boolean;
  isAddingNew: boolean;
  editableReplicationId: string | undefined;
  editingReplicationChangingActiveStatus: boolean;
}

const defaultState: ReplicationsUiState = {
  replicationsListFilter: ReplicationsListFilter.All,
  selectedReplicationId: undefined,
  selectedReplicationVersionId: undefined,
  isVersionDetailsOpened: false,
  isAddingNew: false,
  editableReplicationId: undefined,
  editingReplicationChangingActiveStatus: false,
};

export const replicationsUi = (
  state: ReplicationsUiState = defaultState,
  { type, payload }: Action,
): ReplicationsUiState => {
  switch (type) {
    case REPLICATIONS_UI_ACTION_NAMES.SET_REPLICATIONS_LIST_FILTER:
      return {
        ...state,
        selectedReplicationId: undefined,
        selectedReplicationVersionId: undefined,
        isVersionDetailsOpened: false,
        replicationsListFilter: payload,
      };

    case REPLICATIONS_UI_ACTION_NAMES.SELECT_REPLICATION:
      return {
        ...state,
        editableReplicationId: payload,
      };

    case REPLICATIONS_UI_ACTION_NAMES.HIDE_VERSION_DETAILS:
      return {
        ...state,
        isVersionDetailsOpened: false,
      };

    case REPLICATIONS_UI_ACTION_NAMES.START_EDIT_REPLICATION:
      return {
        ...state,
        editableReplicationId: payload,
      };

    case REPLICATIONS_UI_ACTION_NAMES.CANCEL_EDIT_REPLICATION:
    case REPLICATIONS_LIST_ACTION_NAMES.UPDATE_REPLICATION_SUCCESS:
      return {
        ...state,
        editableReplicationId: undefined,
      };

    case REPLICATIONS_UI_ACTION_NAMES.START_NEW_REPLICATION:
      return {
        ...state,
        isAddingNew: true,
      };

    case REPLICATIONS_UI_ACTION_NAMES.CANCEL_NEW_REPLICATION:
      return {
        ...state,
        isAddingNew: false,
      };

    case REPLICATIONS_LIST_ACTION_NAMES.CREATE_SUCCESS:
      return {
        ...state,
        selectedReplicationVersionId: undefined,
        isVersionDetailsOpened: false,
        isAddingNew: false,
      };

    case REPLICATIONS_LIST_ACTION_NAMES.CHANGE_REPLICATION_ACTIVE_STATUS_START:
      return {
        ...state,
        editingReplicationChangingActiveStatus: true,
      };

    case REPLICATIONS_LIST_ACTION_NAMES.CHANGE_REPLICATION_ACTIVE_STATUS_SUCCESS:
    case REPLICATIONS_LIST_ACTION_NAMES.CHANGE_REPLICATION_ACTIVE_STATUS_ERROR:
      return {
        ...state,
        editingReplicationChangingActiveStatus: false,
      };

    default:
      return state;
  }
};
